import { motion } from 'framer-motion';
import { Star, Zap } from 'lucide-react';

const featuredReaders = [
  {
    id: 1,
    name: 'Emilynn',
    specialty: 'Tarot & Spiritual Guidance',
    rating: 4.9,
    reviews: 328,
    isOnline: true,
    image: 'https://i.postimg.cc/s2ds9RtC/FOUNDER.jpg',
    rate: '$5.99/min',
  },
  {
    id: 2,
    name: 'Luna Rose',
    specialty: 'Psychic Readings & Aura',
    rating: 4.8,
    reviews: 256,
    isOnline: true,
    image: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop',
    rate: '$4.99/min',
  },
  {
    id: 3,
    name: 'Celestina',
    specialty: 'Oracle & Life Guidance',
    rating: 4.7,
    reviews: 189,
    isOnline: false,
    image: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop',
    rate: '$3.99/min',
  },
];

export function FeaturedReaders() {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.3,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8 },
    },
  };

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto">
      <motion.div
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: '-100px' }}
      >
        {/* Section Header */}
        <motion.div variants={itemVariants} className="text-center mb-16">
          <div className="inline-block mb-4">
            <Zap className="w-6 h-6 text-accent fill-accent" />
          </div>
          <h2 className="font-heading text-4xl md:text-5xl text-primary mb-4">
            Featured Readers
          </h2>
          <p className="font-body text-lg text-muted-foreground max-w-2xl mx-auto">
            Connect instantly with our most beloved spiritual guides
          </p>
        </motion.div>

        {/* Readers Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {featuredReaders.map((reader) => (
            <motion.div
              key={reader.id}
              variants={itemVariants}
              className="celestial-border bg-card/80 backdrop-blur rounded-xl overflow-hidden hover:shadow-lg hover:shadow-primary/20 transition-all duration-300 group"
            >
              {/* Online Badge */}
              {reader.isOnline && (
                <div className="absolute top-4 right-4 z-10 flex items-center gap-2 bg-green-500/90 text-white px-3 py-1 rounded-full text-xs font-semibold">
                  <div className="w-2 h-2 bg-white rounded-full animate-pulse" />
                  Online
                </div>
              )}

              {/* Reader Image */}
              <div className="relative h-48 overflow-hidden bg-gradient-to-b from-secondary/20 to-background">
                <img
                  src={reader.image}
                  alt={reader.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
              </div>

              {/* Reader Info */}
              <div className="p-6">
                <h3 className="font-heading text-2xl text-primary mb-2">
                  {reader.name}
                </h3>
                <p className="text-muted-foreground text-sm mb-4 font-body">
                  {reader.specialty}
                </p>

                {/* Rating */}
                <div className="flex items-center gap-2 mb-4">
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <Star
                        key={i}
                        className="w-4 h-4 text-accent fill-accent"
                      />
                    ))}
                  </div>
                  <span className="text-sm text-muted-foreground font-body">
                    {reader.rating} ({reader.reviews})
                  </span>
                </div>

                {/* Rate and CTA */}
                <div className="flex items-center justify-between pt-4 border-t border-border/30">
                  <span className="font-heading text-primary text-lg">
                    {reader.rate}
                  </span>
                  <button
                    disabled={!reader.isOnline}
                    className="bg-primary hover:bg-primary-dark disabled:opacity-50 disabled:cursor-not-allowed text-background px-4 py-2 rounded-lg font-body text-sm transition-all duration-300"
                  >
                    {reader.isOnline ? 'Chat Now' : 'Schedule'}
                  </button>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </motion.div>
    </section>
  );
}
